module.exports = __webpack_public_path__ + "img/cohete-parrafo_uno.ed4dee8b.jpg";